module.exports = __webpack_public_path__ + "img/11_f.0062a228.jpg";